import httpClient from './httpClient';

const RealizarTarea = (pedido) => {    
    return httpClient.post('AppPedido/realizarTarea', pedido);
};

export default RealizarTarea;